import { render, staticRenderFns } from "./FilmTabImage.vue?vue&type=template&id=a6b19416&scoped=true&"
import script from "./FilmTabImage.vue?vue&type=script&lang=js&"
export * from "./FilmTabImage.vue?vue&type=script&lang=js&"
import style0 from "./FilmTabImage.vue?vue&type=style&index=0&id=a6b19416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b19416",
  null
  
)

component.options.__file = "FilmTabImage.vue"
export default component.exports